import {SearchError} from './SearchError.js'

export class GetAggregationsSearchError extends SearchError {
  static create(message) {
    return GetAggregationsSearchError(message)
  }
}
